<template>
  <v-app>
    <vertical-nav-menu :is-drawer-open.sync="isDrawerOpen"></vertical-nav-menu>

    <v-app-bar
      app
      flat
      absolute
      color="transparent"
    >
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon
            class="d-block d-lg-none me-2"
            @click="isDrawerOpen = !isDrawerOpen"
          ></v-app-bar-nav-icon>

          <!-- searcher field -->
          <v-text-field
            v-model="search"
            rounded
            dense
            outlined
            :prepend-inner-icon="icons.mdiMagnify"
            class="app-bar-search flex-grow-0"
            hide-details
            :disabled="searchDisabled"
            placeholder="Scan barcode..."
            @keyup.enter="addVisit"
          ></v-text-field>

          <v-spacer></v-spacer>

          <!-- Right Content -->
          <!--
					<a
						href="https://github.com/themeselection/materio-vuetify-vuejs-admin-template-free"
						target="_blank"
						rel="nofollow"
					>
						<v-icon class="ms-6 me-4">
							{{ icons.mdiGithub }}
						</v-icon>
					</a>
					-->
          <theme-switcher></theme-switcher>
          <!--
					<v-btn
						icon
						small
						class="ms-3"
					>
						<v-icon>
							{{ icons.mdiBellOutline }}
						</v-icon>
					</v-btn>
					-->
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <v-footer
      app
      inset
      color="transparent"
      absolute
      height="56"
      class="px-0"
    >
      <div class="boxed-container w-full">
        <div class="mx-6 d-flex justify-space-between">
          <span>
            &copy; {{ currentYear }} <a
              href="javascript:void(0)"
              class="text--secondary text-decoration-none"
            >All rights reserved</a>
          </span>
          <span class="d-sm-inline d-none">
            <a
              href="javascript:void(0)"
              class="me-6 text-decoration-none"
            >Contact</a>
            <a
              href="javascript:void(0)"
              class="me-6 text-decoration-none"
            >Terms and conditions</a>
            <span
              class="text--secondary text-decoration-none"
            >Made with ❤️ by JP</span>
          </span>
        </div>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiMagnify, mdiBellOutline, mdiGithub } from '@mdi/js'
import Swal from 'sweetalert2'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'

import { axiosInst } from '@/utils/axiosIns'
import { AmILogged } from '@/utils/sess-handler'

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
  },

  setup() {
    const isDrawerOpen = ref(null)

    return {
      isDrawerOpen,

      // Icons
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
      },

      search: '',
      searchDisabled: false,
      currentYear: new Date().getFullYear(),
    }
  },

  beforeMount() {
    if (!AmILogged()) this.$router.push({ name: 'pages-login' })
  },

  methods: {
    async addVisit() {
      try {
        this.searchDisabled = true
        if (this.search.length !== 24) throw new Error('Barcode seems to be incorrect')

        const rs = await axiosInst.post('client-post', {
          clientId: this.search,
        }).catch(err => { throw err })

        // console.log(rs)

        if (rs.status === 200 && rs.data.error === false) {
          Swal.fire('Added!', 'Record has been added.', 'success')
        }
      } catch (err) {
        Swal.fire('Error!', (err.response ? err.response.data.r : err.message), 'error')
        console.error(err)
      } finally {
        this.searchDisabled = false
        this.search = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
	.v-toolbar__content {
		padding: 0;

		.app-bar-search {
			.v-input__slot {
				padding-left: 18px;
			}
		}
	}
}

.boxed-container {
	max-width: 1440px;
	margin-left: auto;
	margin-right: auto;
}
</style>
